export default __webpack_public_path__ + "static/media/AwesomeAir_01.dcee1926.png";